(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["z-anchor"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('z-anchor')) {
    class ZAnchor extends HTMLElement {
      connectedCallback() {
        if (!window.Shopify?.designMode) return;
        queueMicrotask(() => ZAnchor.updateDuplicates(this.id));
      }

      disconnectedCallback() {
        if (!window.Shopify?.designMode) return;
        const anchorId = this.id;
        queueMicrotask(() => ZAnchor.updateDuplicates(anchorId));
      }

      static updateDuplicates(anchorId) {
        if (!anchorId) return;

        const matches = document.querySelectorAll(`#${CSS.escape(anchorId)}`);
        const isDuplicate = matches.length > 1;

        matches.forEach((match) => {
          if (match instanceof ZAnchor) {
            match.classList.toggle('z-anchor--duplicate', isDuplicate);
          }
        });
      }
    }

    customElements.define('z-anchor', ZAnchor);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["z-media"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('z-media')) {
    class ZMedia extends HTMLElement {
      connectedCallback() {
        if (this.dataset.zInitialized === 'true') return;

        this.dataset.zInitialized = 'true';
        this.abortController = new AbortController();
        this.openButton = this.querySelector('[data-z-media-open]');
        this.closeButton = this.querySelector('[data-z-media-close]');
        this.dialog = this.querySelector('[data-z-media-dialog]');
        this.autoplayVideos = Array.from(this.querySelectorAll('.z-media__video'));
        this.dialogVideos = Array.from(this.querySelectorAll('video.z-media__dialog-video'));
        this.externalVideo = this.querySelector('[data-z-external-src]');
        this.autoplayControl = this.querySelector('[data-z-autoplay-control]');
        this.motionQuery = matchMedia('(prefers-reduced-motion: reduce)');
        // zoesvision.com | 2026-08-15 | Purpose: Keep media mobile behavior active through tablet widths.
        this.mobileQuery = matchMedia('(max-width: 989px)');
        // zoesvision.com | 2026-08-16 | Purpose: Gate autoplay by viewport visibility and the selected state of an owning Z carousel.
        this.isInViewport = false;
        this.isCarouselManaged = false;
        this.isCarouselActive = false;
        // zoesvision.com | 2026-08-19 | Purpose: Separate carousel prewarming from active playback state.
        this.isCarouselPreload = false;
        this.isDialogOpen = false;
        this.isUserPaused = false;
        this.restartOnNextPlay = this.dataset.zLoop !== 'true';
        this.autoplayObserver = new IntersectionObserver(this.handleAutoplayIntersection, {
          threshold: 0.15
        });
        const signal = this.abortController.signal;

        this.openButton?.addEventListener('click', this.openDialog, { signal });
        this.autoplayControl?.addEventListener('click', this.handleAutoplayControl, { signal });
        this.closeButton?.addEventListener('click', this.closeDialog, { signal });
        this.dialog?.addEventListener('click', this.handleDialogClick, { signal });
        this.dialog?.addEventListener('close', this.handleDialogClose, { signal });
        this.motionQuery.addEventListener('change', this.syncAutoplay, { signal });
        this.mobileQuery.addEventListener('change', this.syncAutoplay, { signal });
        document.addEventListener('visibilitychange', this.syncAutoplay, { signal });
        this.addEventListener('z:media-carousel-active', this.handleCarouselActive, { signal });
        this.addEventListener('z:media-carousel-release', this.handleCarouselRelease, { signal });
        this.autoplayVideos.forEach((video) => {
          video.addEventListener('play', this.syncAutoplayControl, { signal });
          video.addEventListener('pause', this.syncAutoplayControl, { signal });
          video.addEventListener('ended', this.syncAutoplayControl, { signal });
          video.addEventListener('durationchange', this.syncAutoplayControl, { signal });
        });
        this.autoplayObserver.observe(this);
        this.syncAutoplay();
      }

      disconnectedCallback() {
        this.abortController?.abort();
        this.autoplayObserver?.disconnect();
        if (this.dialog?.open) this.dialog.close();
        this.resetVideos(this.dialogVideos || []);
        this.resetExternalVideo();
        this.pauseVideos(this.autoplayVideos || []);
        this.cancelProgressUpdate();
        this.activeAutoplayVideo = undefined;
        delete this.dataset.zInitialized;
      }

      openDialog = () => {
        if (!this.dialog || this.dialog.open) return;

        this.isDialogOpen = true;
        this.syncAutoplay();
        this.dialog.showModal();
        if (this.externalVideo?.dataset.zExternalSrc) {
          this.externalVideo.src = this.externalVideo.dataset.zExternalSrc;
        }
        const video = this.getActiveVideo(this.dialogVideos);
        if (video) video.preload = 'metadata';
        video?.play().catch(() => {});
      };

      closeDialog = () => {
        if (this.dialog?.open) this.dialog.close();
      };

      handleDialogClick = (event) => {
        if (event.target === this.dialog) this.closeDialog();
      };

      handleDialogClose = () => {
        this.resetVideos(this.dialogVideos);
        this.dialogVideos.forEach((video) => {
          video.preload = 'none';
        });
        this.resetExternalVideo();
        this.isDialogOpen = false;
        this.syncAutoplay();
        if (this.isConnected) this.openButton?.focus();
      };

      handleAutoplayControl = () => {
        const video = this.getActiveVideo(this.autoplayVideos);
        if (!video) return;

        if (video.ended) {
          this.isUserPaused = false;
          video.currentTime = 0;
          video.play().catch(() => {});
        } else if (video.paused) {
          this.isUserPaused = false;
          video.play().catch(() => {});
        } else {
          this.isUserPaused = true;
          video.pause();
        }
        this.syncAutoplayControl();
      };

      handleAutoplayIntersection = (entries) => {
        const isInViewport = entries.some((entry) => entry.isIntersecting);
        if (isInViewport && !this.isInViewport && this.dataset.zLoop !== 'true') {
          this.restartOnNextPlay = true;
        }
        this.isInViewport = isInViewport;
        this.syncAutoplay();
      };

      handleCarouselActive = (event) => {
        const wasManaged = this.isCarouselManaged;
        const wasActive = this.isCarouselActive;
        this.isCarouselManaged = true;
        this.isCarouselActive = event.detail?.active === true;
        this.isCarouselPreload = event.detail?.preload === true;
        if (this.isCarouselActive && (!wasManaged || !wasActive) && this.dataset.zLoop !== 'true') {
          this.restartOnNextPlay = true;
        }
        this.syncAutoplay();
      };

      handleCarouselRelease = () => {
        const wasInactive = this.isCarouselManaged && !this.isCarouselActive;
        this.isCarouselManaged = false;
        this.isCarouselActive = false;
        this.isCarouselPreload = false;
        if (wasInactive && this.dataset.zLoop !== 'true') this.restartOnNextPlay = true;
        this.syncAutoplay();
      };

      syncAutoplay = () => {
        const isAutoplayMode = this.dataset.zPlayback === 'autoplay'
          || this.dataset.zPlayback === 'autoplay_modal';
        const shouldPlay = isAutoplayMode
          && document.visibilityState === 'visible'
          && !this.motionQuery.matches
          && this.isInViewport
          && !this.isDialogOpen
          && !this.isUserPaused
          && (!this.isCarouselManaged || this.isCarouselActive);
        const activeVideo = this.getActiveVideo(this.autoplayVideos);
        const shouldPreload = this.isInViewport
          && (!this.isCarouselManaged || this.isCarouselPreload);
        this.autoplayVideos.forEach((video) => {
          video.preload = shouldPreload && video === activeVideo ? 'metadata' : 'none';
        });

        this.autoplayVideos.forEach((video) => {
          if (video !== activeVideo) video.pause();
        });

        if (!shouldPlay || !activeVideo) {
          this.pauseVideos(this.autoplayVideos);
          this.syncAutoplayControl();
          return;
        }

        const sourceChanged = activeVideo !== this.activeAutoplayVideo;
        if (this.restartOnNextPlay && this.dataset.zLoop !== 'true') {
          try {
            activeVideo.currentTime = 0;
          } catch {
            // The media metadata may not be available yet.
          }
          this.restartOnNextPlay = false;
        }

        if (!activeVideo.ended || sourceChanged) activeVideo.play().catch(() => {});
        this.activeAutoplayVideo = activeVideo;
        this.syncAutoplayControl();
      };

      syncAutoplayControl = () => {
        if (!this.autoplayControl) return;

        const video = this.getActiveVideo(this.autoplayVideos);
        this.cancelProgressUpdate();
        if (!video) return;

        const state = video.ended ? 'replay' : video.paused ? 'play' : 'pause';
        const labels = { play: 'Play video', pause: 'Pause video', replay: 'Replay video' };
        this.autoplayControl.dataset.zState = state;
        this.autoplayControl.setAttribute('aria-label', labels[state]);
        this.updateAutoplayProgress(video);
        if (!video.paused && !video.ended) this.progressFrame = requestAnimationFrame(this.updateProgressFrame);
      };

      updateProgressFrame = () => {
        const video = this.getActiveVideo(this.autoplayVideos);
        if (!video || video.paused || video.ended) {
          this.syncAutoplayControl();
          return;
        }
        this.updateAutoplayProgress(video);
        this.progressFrame = requestAnimationFrame(this.updateProgressFrame);
      };

      updateAutoplayProgress(video) {
        const progress = video.duration > 0 ? Math.min(video.currentTime / video.duration, 1) : 0;
        this.autoplayControl?.style.setProperty('--z-autoplay-progress', `${progress * 360}deg`);
      }

      cancelProgressUpdate() {
        if (this.progressFrame) cancelAnimationFrame(this.progressFrame);
        this.progressFrame = undefined;
      }

      getActiveVideo(videos) {
        if (!videos?.length) return null;

        const suffix = this.mobileQuery.matches ? '--mobile' : '--desktop';
        return videos.find((video) => video.className.includes(suffix)) || videos[0];
      }

      pauseVideos(videos) {
        videos.forEach((video) => video.pause());
      }

      resetVideos(videos) {
        videos.forEach((video) => {
          video.pause();
          try {
            video.currentTime = 0;
          } catch {
            // The media metadata may not be available yet.
          }
        });
      }

      resetExternalVideo() {
        this.externalVideo?.removeAttribute('src');
      }
    }

    customElements.define('z-media', ZMedia);
  }
  } catch(e) { console.error(e); }
})();

})();
